import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myKeywordAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('keyword', payload.keyword);
    return axios.post(config.apiUri + "member/myKeywordEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['keyword'],
    		},
      });
      yield put({
        type: "COMMUNITY_KEYWORD_POP_LIST_INIT",
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'キーワードを追加しました'} });
      action.callback();
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myKeywordDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('id', payload.id);
    return axios.post(config.apiUri + "member/myKeywordEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['keyword'],
    		},
      });
      yield put({
        type: "COMMUNITY_KEYWORD_POP_LIST_INIT",
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('MY_KEYWORD_ADD', myKeywordAdd),
  takeLatest('MY_KEYWORD_DEL', myKeywordDel),
];

export default saga;
